import React from 'react';
import { Container as MuiContainer } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * Primitive Container component
 * Styled version of MUI Container that respects the theme
 */
const Container = ({ children, maxWidth = 'lg', ...props }) => {
  const theme = useTheme();

  return (
    <MuiContainer
      maxWidth={maxWidth}
      {...props}
      sx={{
        ...props.sx,
      }}
    >
      {children}
    </MuiContainer>
  );
};

export default Container;

